import { put } from 'redux-saga/effects';
import actions from '../../../../actions';

export function* handleProjectUpdate(project, projectProfessions) {
  yield put(actions.handleProjectUpdate(project, projectProfessions));
}
